import * as Yup from 'yup';
import { getSelectSchema, getStringSchema } from 'src/compass/shared/schemas';
import { Terms } from 'src/compass/shared/util/terms';

export const CustomerSchema = Yup.object().shape(
  {
    name: getStringSchema(255, 'Name'),
    crmCompositeObj: getSelectSchema(`${Terms.CRM.label} Contact/Company`),
    rmcOfRecordEmployeeId: getSelectSchema('RMC of Record'),
    grouping: getStringSchema(255, 'Grouping').notRequired(),
    sourceEmployeeId: Yup.mixed().when('sourceId', {
      is: (sourceId: any) => sourceId != null,
      then() {
        return getSelectSchema('', 'Required when "Type" is entered');
      },
      otherwise(schema) {
        return schema.notRequired();
      },
    }),
    sourceId: Yup.mixed().when('sourceEmployeeId', {
      is: (sourceEmployeeId: any) => sourceEmployeeId != null,
      then() {
        return getSelectSchema('', 'Required when "Source Employee" is entered');
      },
      otherwise(schema) {
        return schema.notRequired();
      },
    }),
  },
  [['sourceId', 'sourceEmployeeId']]
);
